export default __webpack_public_path__ + "static/media/JeepFavicon.6dfa5c40.ico";